import * as THREE from 'three';
import {createLineMesh} from './line';
import {createBasicShader} from "./shaders/basic";

const Line = createLineMesh(THREE);
const BasicShader = createBasicShader(THREE);

const fitCoordinatesIntoScene = (x, y, width, height, sceneWidth, sceneHeight) => {
  let sceneX = ((x / width) * sceneWidth) - (sceneWidth / 2);
  let sceneY = -((y / height) * sceneHeight) + (sceneHeight / 2);
  return [sceneX, sceneY];
};

const parseClickCoordinates = ( {
  videoHeight,
  videoWidth,
  originalX,
  originalY
}) => ({
  videoHeight: Math.round(videoHeight),
  videoWidth: Math.round(videoWidth),
  originalX: Math.round(originalX),
  originalY: Math.round(originalY)
});


const createLine = (color, path = []) => {
  let line = Line(path);
  let mat = new THREE.ShaderMaterial(BasicShader({
    side: THREE.DoubleSide,
    diffuse: color,
    thickness: 0.015,
    opacity: 0.9,
  }));

  let mesh = new THREE.Mesh(line, mat);
  return {line, mesh};
};

const initializeDrawing = (renderer, drawingsArray, cb) => {
  let rendererSize = new THREE.Vector2();
  let width = renderer.getSize(rendererSize).x;
  let height = renderer.getSize(rendererSize).y;
  let aspect = width / height;

  let left = 2 * aspect / -2;
  let right = 2 * aspect / 2;
  let top = 1, bottom = -1;
  let drawSceneWidth = right - left;
  let drawSceneHeight = top - bottom;

  let drawScene = new THREE.Scene();
  let drawCamera = new THREE.OrthographicCamera(left, right, top, bottom, -1, 1);

  let drawPoints = [];
  let currentLine;
  let isDrawing = false;
  let isMouseDown = false;
  let initialX = 0, initialY = 0, isPotentialDraw = 0;


  const startPotentialDraw = () => {
    isPotentialDraw = true;
  };

  const canBecomeDrawing = (e) => {
    return isPotentialDraw
      && (
        Math.abs(e.clientX - initialX) > 5 ||
        Math.abs(e.clientY - initialY) > 5
      )
  };

  const startDrawing = (e) =>  {
    if(canBecomeDrawing(e)) {
      isPotentialDraw = false;
      isDrawing = true;
      let rect = e.target.getBoundingClientRect();
      let x = initialX - rect.left; //x position within the element.
      let y = initialY - rect.top;  //y position within the element.

      let [sceneX, sceneY] = fitCoordinatesIntoScene(x, y, width, height, drawSceneWidth, drawSceneHeight);
      drawPoints = [[sceneX, sceneY]];

      let {line, mesh} = createLine(0x449DDD);
      drawScene.add(mesh);
      currentLine = line;

      drawingsArray.push(mesh);

      cb && cb(true, parseClickCoordinates({
        videoHeight: height,
        videoWidth: width,
        originalX: x,
        originalY: y
      }))
    }
  };

  const draw = (e) => {
    if(isDrawing) {
      let rect = e.target.getBoundingClientRect();
      let x = e.clientX - rect.left; //x position within the element.
      let y = e.clientY - rect.top;  //y position within the element.
      let [sceneX, sceneY] = fitCoordinatesIntoScene(x, y, width, height, drawSceneWidth, drawSceneHeight);
      let lastPoint = drawPoints[drawPoints.length - 1];

      //check if distance between points is larger than zero
      if((lastPoint && Math.hypot(lastPoint[0]-sceneX, lastPoint[1] - sceneY)) || !lastPoint) {
        drawPoints.push([sceneX, sceneY]);
        currentLine.update(drawPoints);
      }

      cb && cb(true, parseClickCoordinates({
        videoHeight: height,
        videoWidth: width,
        originalX: x,
        originalY: y
      }))
    }
  };

  const handleMouseDown = (e) => {
    isMouseDown = true;
    let rect = e.target.getBoundingClientRect();
    let x = e.clientX - rect.left; //x position within the element.
    let y = e.clientY - rect.top;  //y position within the element.

    initialX = e.clientX;
    initialY = e.clientY;
    startPotentialDraw();
  };

  const handleTouchstart = (e) => {
    handleMouseDown(e.touches[0])
  };

  const handleMouseMove = (e) => {
    if(!isMouseDown) {
      return
    }
    startDrawing(e)
    draw(e)
  };

  const handleTouchMove = (e) => {
    handleMouseMove(e.touches[0])
  };


  const handleMouseUp = (e) => {
    if(!isMouseDown) {
      return
    }

    if(!isDrawing) {
      sendClickData(e);
    }
    handleMouseMove(e);

    if(isDrawing) {
      cb(null, null, true);
    }
    isDrawing = false;
    isPotentialDraw = false;
    isMouseDown = false;
    // currentLine.update(drawPoints);

  };

  const handleTouchEnd = (e) => {
    if(!isDrawing) {
      sendClickData(e)
    }
    isDrawing = false;
  };

  const sendClickData = (e) => {
    let rect = e.target.getBoundingClientRect();
    let x = initialX - rect.left; //x position within the element.
    let y = initialY - rect.top;  //y position within the element.

    cb && cb(false, parseClickCoordinates({
      videoHeight: height,
      videoWidth: width,
      originalX: x,
      originalY: y
    }))
  };

  // renderer.domElement.addEventListener('click', handleClick);
  renderer.domElement.addEventListener('mousedown', handleMouseDown);
  renderer.domElement.addEventListener('mousemove', handleMouseMove);
  renderer.domElement.addEventListener('mouseup', handleMouseUp);
  renderer.domElement.addEventListener('mouseleave', handleMouseUp);
  renderer.domElement.addEventListener('touchstart', handleTouchstart);
  renderer.domElement.addEventListener('touchmove', handleTouchMove);
  renderer.domElement.addEventListener('touchend', handleTouchEnd);
  renderer.domElement.addEventListener('touchleave', handleTouchEnd);

  return {drawCamera, drawScene, drawingsArray, drawSceneWidth, drawSceneHeight}
};

export {
  initializeDrawing,
  createLine,
  fitCoordinatesIntoScene
}
